const reservationHu = {
    "arriving_status": "Érkezik: {{count}} foglalás, {{guests}} fő",
    "in_restaurant_status": "Étteremben: {{count}} foglalás, {{guests}} fő",
    "reservation": "Foglalás",
    "waiting_list": "Várólista",
    "not_approved": "Visszajelzésre vár",
    "not_assigned_to_table": "Nincs asztalhoz rendelve",
    "arrived_guests": "Érkeztetve",
    "guest_note": "Vendég megjegyzés",
    "guest_name": "Név",
    "guest_email": "E-mail",
    "guest_phone": "Telefonszám",
    "guests_comment": "Vendég megjegyzése",
    "source": "Forrás",
    "reservation_date": "Foglalás dátuma",
    "reservation_time": "Foglalás időpontja",
    "guest_count": "Vendégek száma",
    "add_reservation": "Foglalás hozzáadása",
    "not_arrived": "Nem érkezett meg",
    "reservation_fee_table_title": "Foglalási díjas foglalások a kiválasztott időszakban",
    "sent_sms_table_title": "Elküldött sms-ek a kiválasztott időszakban",
    "invoices_table_title": "Számlák a kiválasztott időszakban",
    "reservation_fee": "Foglalási díj",
    "coupon_code": "Kupon kód",
    "reservation_created_at": "Foglalás létrehozva",
    "reservation_labels": "Foglalás címkék",
    "guest_labels": "Vendég címkék",
    "guest_internal_comment": "Vendégtörzs megjegyzés",
    "no_shows": "No show",
    "late_cancellations": "Késői lemondások",
    "reservedon": "Foglalás Időpontja",
    "occupancy": "foglaltság",
    "default_sources": {
        "email": "Email",
        "phone": "Telefon",
        "other": "Egyéb"
    },
    "reservation_details_saved": "Foglalási részletek sikeresen mentve",
    "reservation_guest_info_saved": "Foglalási vendég információ sikeresen mentve",
    "approved": "Státusz",
    "approved_options": {
        "-1": "Törölve",
        "0": "Jóváhagyásra vár",
        "1": "Jóváhagyva",
        "2": "Megérkezett",
        "3": "No show",
        "4": "Távozott",
        "5": "Részlegesen megérkezett"
    },
    "approved_statistics": {
        "arrived": "Megérkezett",
        "approved": "Jóváhagyva",
        "deleted": "Törölve",
        "n_a": "N/A",
        "no_show": "No-show",
        "walk_in": "Beeső vendég"
    },
    "reservation_length_not_set_placeholder": "Mentés idejétől függően kerül beállításra",
    "send_confirmation_email": "Megerősítő email",
    "message_language_options": {
        "hu": "Magyar",
        "unknown": "Ismeretlen",
        "en": "Angol",
        "ru": "Orosz",
        "de": "Német",
        "fr": "Francia",
        "es": "Spanyol",
        "it": "Olasz",
        "sk": "Szlovák",
        "uk": "Ukrán",
        "hr": "Horvát",
        "he": "Héber"
    },
    "walkin": "Beeső vendég",
    "confirm_message_language": "Megerősítő email nyelve",
    "editor_tabs": {
        "reservation": "Foglalás",
        "guest": "Vendég",
        "guest_history": "Vendég előzmények",
        "email": "Email",
        "sms": "SMS",
        "reviews": "Vélemények",
        "merge": "Összevonás",
        "attachments": "Csatolmányok",
        "ntak_history": "POS fogyasztási adatok",
        "old_states": "Módosítások"
    },
    "reservations_without_tables": "Asztal nélküli foglalások",
    "create_new_reservation": "Új foglalás rögzítése",
    "new_resrvation_tabs": {
        "reservation": "Foglalás",
        "walkin": "Beeső vendég"
    },
    "hungarian_or_foreign": "Belföldi vagy külföldi vendég?",
    "no_name_saved": "Nincs név megadva",
    "walkin_saved": "Beeső vendég sikeresen mentve",
    "reservation_saved": "Foglalás sikeresen mentve",
    "reservation_approved": "Foglalás jóváhagyva",
    "reservation_declined": "Foglalás elutasítva",
    "reservation_deleted": "Foglalás törölve",
    "auto_apply_is_on": "Automatikus hozzárendelés",
    "seat_reservation": "Asztalhoz rendelés",
    "unseat_reservation": "Levétel az asztalról",
    "seat_successful": "Asztalhoz rendelés sikeres",
    "unseat_successful": "Levétel az asztalról sikeres",
    "arrived": "Megérkezett",
    "no_show": "Nem jött el",
    "partially_arrived": "Részlegesen megérkezett",
    "reservation_status_updated": "Foglalás státusza frissítve",
    "reservation_ended": "Távozott",
    "reset_status": "Státusz visszaállítása",
    "status_actions": {
        "approve": "Jóváhagyás",
        "decline": "Elutasítás",
        "delete": "Törlés",
        "reset": "Visszaállítás",
        "arrived": "Megérkezett",
        "partially_arrived": "Részlegesen megérkezett",
        "noshow": "Nem jött el",
        "ended": "Távozott",
        "seat": "Asztalhoz rendelés",
        "unseat": "Levétel az asztalról"
    },
    "guests_per_day_30_days": "Vendégek naponta (utolsó 30 nap)",
    "guests_per_day_12_weeks": "Vendégek hetente (utolsó 12 hét)",
    "guests_per_day_12_months": "Vendégek havonta (utolsó 12 hónap)",
    "reservation_country_hungary": "Magyarország",
    "reservation_country_foreign": "Külföld",
    "reservation_country_unknown": "Nincs megadva telefonszám",
    "reservations_by_source": "Vendégek forrás alapján",
    "reservations_by_country": "Vendégek ország alapján",
    "reservations_by_status": "Vendégek státusz alapján",
    "guest_distribution": "Vendégek eloszlása",
    "upcoming_reservations": "Közelgő foglalások",
    "seated_reservations": "Megérkezett foglalások",
    "reservaton_ends": "Foglalás vége",
    "event_at_this_date": "Ebben az időpontban: ",
    "late_cancellation_helper_text": "A vendég kevesebb mint 6 órával az érkezési idő előtt törölte a foglalását",
    "resend_confirmation_mail": "Megerősítő email újraküldése",
    "approval_resent": "Jóváhagyás újraküldve",
    "reservation_type": "Foglalás típusa",
    "max_reservation_file_size_exceeded": "A csatolmány mérete meghaladja a megengedett maximumot.",
    "max_attachment_file_size": "Maximális fájl méret: ",
    "attachment_file_size": "Feltöltött fájl mérete: ",
    "maximum_reservation_attachments_exceeded": "A foglaláshoz tartozó csatolmányok mérete összesen nem haladhatja meg a {{maxSize}} értéket.",
    "current_total_attachments_size": "Jelenlegi összes csatolmány mérete: {{size}}",
    "upload_not_allowed": "Feltöltés nem engedélyezett",
    "change_time_confirmation": "Biztosan módosítja a foglalás időpontját?",
    "evict_confirmation": "Biztosan leveszi ezt a foglalást az asztalról?",
    "no_table_section": "Asztal nélkül",
    "timetable_settings": "Idősávos nézet beállítások",
    "timetable_allow_eviction": "Foglalt asztalra helyezés engedélyezése",
    "timetable_allow_time_change": "Időpont módosítás húzással",
    "timetable_allow_on_touch": "Húzás engedélyezése érintőképernyőn",
    "timetable_show_no_table": "Asztal nélküli foglalások megjelenítése",
    "timetable_group_by_time": "Foglalások csoportosítása időpont szerint",
    "timetable_show_full_day": "Teljes nap megjelenítése",
    "clear_tables_for_day": "Minden foglalás levétele asztalokról",
    "clear_tables_confirm": "Biztosan leveszed az összes foglalást az asztalokról ezen a napon?",
    "clear_tables_success": "Minden foglalás sikeresen le lett véve az asztalokról",
    "reservations_panel": "Foglalások panel",
    "old_states_tip": "Ezen a foglaláson módosítást végzett a vendég. Az alábbiakban megtekintheti a foglalás korábbi állapotait, valamint a módosítások időpontját.",
    "old_states_warning": "A lista nem tartalmazza az admin felületen végzett változtatásokat"
}

export default reservationHu;